import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useFormContentBlocker } from "../../../../../contexts/formContentBlocker.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormContentBlockerFieldTechnicalCriteria = ()=>{
    const { __ } = useI18n();
    const { isTcf } = useFormContentBlocker();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Block by"),
        required: true,
        style: {
            display: isTcf ? undefined : "none"
        },
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "criteria",
                noStyle: true,
                rules: [
                    {
                        required: true,
                        message: __("Please choose an option!")
                    }
                ],
                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                    children: [
                        /*#__PURE__*/ _jsx(Radio.Button, {
                            value: "services",
                            children: __("Services")
                        }),
                        /*#__PURE__*/ _jsx(Radio.Button, {
                            value: "tcfVendors",
                            children: __("TCF Vendors")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("You can block content through non-standard services or TCF vendors. If you want to block it through TCF vendors, then the visual content blocker cannot be displayed because TCF is usually used to obtain consent for ad networks. Moreover, after the initial consents in the cookie banner, users will probably never consent to the ad.")
            })
        ]
    });
};
export { FormContentBlockerFieldTechnicalCriteria };
